// Блип-отклик ползунка «Звуки» (экран настроек): музыки в мете нет, а выбранную
// громкость нужно услышать сразу. Вызов — только из обработчика жеста
// (pointerup/keyup), автоплей-политика не мешает.
//
// Своего звука у ползунка нет и не будет: он играет не «звук интерфейса», а ПРОБУ
// выставляемой громкости, поэтому берёт её из аргумента, а не из настроек. А вот
// AudioContext теперь общий с metaSfx — второй стоил бы ещё одного аудио-потока,
// и браузеры их лимитируют.

import { metaAudioContext } from './metaSfx';

export function playVolumeBlip(volume: number): void {
  if (volume <= 0) return;
  const ctx = metaAudioContext();
  if (!ctx) return;
  void ctx.resume();
  const t = ctx.currentTime;
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = 'triangle';
  osc.frequency.setValueAtTime(660, t);
  g.gain.setValueAtTime(0.35 * volume, t);
  g.gain.exponentialRampToValueAtTime(0.001, t + 0.12);
  osc.connect(g);
  g.connect(ctx.destination);
  osc.start(t);
  osc.stop(t + 0.15);
}
